import APIConfiguration from '@savgroup-front-common/configuration/api';
import {
  COMMON_QUERY_PARAMS,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants/shared';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

import { StockLabelDto } from './type/StockLabelDto';

const ENDPOINT = `${APIConfiguration.sparePart}stockInventory/availableStock/${COMMON_QUERY_PARAMS.SELLER_ID}`;

export interface GetAvailableStockForInventoryBySellerIdQueryArgs {
  sellerId: string;
}

export default async function getAvailableStockForInventoryBySellerIdQuery(
  payload: GetAvailableStockForInventoryBySellerIdQueryArgs,
): Promise<BackResponse<StockLabelDto[]> | BackResponseFailure> {
  try {
    const response = await apiCall<BackResponse<StockLabelDto[]>>(
      ENDPOINT.replace(COMMON_QUERY_PARAMS.SELLER_ID, payload.sellerId),
      {
        method: SUPPORTED_METHODS.GET,
      },
    );

    return response;
  } catch (error) {
    return prepareResponseFailure(error);
  }
}
